<template>
  <content-box :width="'800px'" class="no-page"
    :class="{ ja: $i18n.locale === 'ja' }">
    <div class="content__top">
      <i class="icon icon--dashboard-encourage-text"
        :class="{ ja: $i18n.locale === 'ja' }"></i>
      <p class="slogan" v-html="$t('dashboard.tryRegisterPage.slogan')"></p>
      <i class="icon icon--dashboard-encourage-graph"></i>
    </div>
    <div class="content__bottom">
      <p class="desc" v-html="$t('dashboard.tryRegisterPage.desc')"></p>
      <ui-button :primary="true"
                :iconName="'icon--plus-white'"
                @click="$router.push({ name: 'page-add' })">{{ $t('common.addPage') }}</ui-button>
    </div>
  </content-box>
</template>

<script>
import ContentBox from '@/components/ui/ContentBox'
import UiButton from '@/components/ui/UiButton'

export default {
  name: 'DashboardNoPage',
  components: {
    ContentBox,
    UiButton
  }
}
</script>

<style lang="scss">
.content--wrap {
  &.no-page {
    margin: 180px auto 0;
    overflow: hidden;
    border-radius: 40px;
    background-color: #2f2f2f;
    background-image: url(../../assets/img/dashboard/bg_dashboard_encourage.png);
    background-size: cover;

    .content__top {
      position: relative;
      height: 360px;
      padding: 102px 30px 0;
      box-sizing: border-box;

      .slogan {
        margin-top: 15px;
        font-size: 18px;
        font-weight: 600;
        line-height: 1.44;
        color: #aaaaaa;
      }

      .icon--dashboard-encourage-graph {
        position: absolute;
        bottom: calc(0px - 15px);
        right: 0;
      }
    }
    .content__bottom {
      @include flexXbetween;
      align-items: center;
      height: 90px;
      padding-left: 34px;
      padding-right: 30px;
      background-color: #fff;
      position: relative;

      .desc {
        font-size: 13px;
        color: #aaaaaa;
      }
    }

    &.ja {
      .content__top .slogan {
        margin-top: 20px;
      }
    }
  }
}
</style>
